import React, { Component } from "react";
import AuthService from "./AuthService";
const Auth = new AuthService();
export const Authorization = allowedRoles => WrappedComponent =>
  class WithAuthorization extends Component {
    constructor(props) {
      super(props);
      this.state = {};
    }

    componentWillMount() {
      if (!Auth.loggedIn()) {
        this.props.history.replace("/login");
      } else {
        try {
          const profile = Auth.getProfile();
          this.setState({
            user: profile
          });
        } catch (err) {
          Auth.logout();
          this.props.history.replace("/login");
        }
      }
    }

    render() {
      if (
        this.state != null &&
        this.state.user != null &&
        Auth.arrayContainsArray(allowedRoles, this.state.user.scope)
      ) {
        return (
          <WrappedComponent
            params={this.props.match.params}
            path={this.props.history}
            user={this.state.user}
          />
        );
      } else {
        return null;
      }
    }
  };



// WEBPACK FOOTER //
// ./src/components/withAuth.js